export default __webpack_public_path__ + "static/media/Sports-Facilities.22a123f2.jpg";